import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgTickBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.074 10a1.22 1.22 0 01-.861-.352l-3.856-3.8a1.187 1.187 0 010-1.697 1.229 1.229 0 011.722 0l2.995 2.95L11.92.35a1.229 1.229 0 011.722 0c.476.47.476 1.229 0 1.698L5.935 9.648a1.218 1.218 0 01-.861.352z",
    fill: "#2355FC"
  })));
}

export { SvgTickBlue as ReactComponent };
//# sourceMappingURL=tick_blue.svg.js.map
